import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="navigation-header">
      <nav className="nav-container">
        {/* Logo and Name */}
        <div className="nav-brand">
          <div className="logo">PK</div>
          <div className="brand-text">
            <span className="name">PAWAN KUMAR</span>
            <span className="title">Asst. Professor</span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <ul className="nav-links">
          <li>
            <button onClick={() => scrollToSection('home')} className="nav-link">
              Home
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('education')} className="nav-link">
              Education
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('experience')} className="nav-link">
              Experience
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('publications')} className="nav-link">
              Publications
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('skills')} className="nav-link">
              Skills
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('contact')} className="nav-link contact-btn">
              Contact
            </button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Navigation */}
        <div className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          <div className="mobile-nav-content">
            <button 
              onClick={() => scrollToSection('home')} 
              className="mobile-nav-link"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('education')} 
              className="mobile-nav-link"
            >
              Education
            </button>
            <button 
              onClick={() => scrollToSection('experience')} 
              className="mobile-nav-link"
            >
              Experience
            </button>
            <button 
              onClick={() => scrollToSection('publications')} 
              className="mobile-nav-link"
            >
              Publications
            </button>
            <button 
              onClick={() => scrollToSection('skills')} 
              className="mobile-nav-link"
            >
              Skills
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="mobile-nav-link contact"
            >
              Contact
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;